/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItem401,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItem404,
} from '../../types/TelegramProductsUserControllerGetDescriptionGenerationQueueItem.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserGetDescriptionGenerationQueueItem } from '../../methods/telegramProductsUserGetDescriptionGenerationQueueItem.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserGetDescriptionGenerationQueueItemQueryKey = (
  queueId: TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams['queueId'],
) =>
  [{ url: '/api/user/telegram/products/description-generation/queue/:queueId', params: { queueId: queueId } }] as const;

export type TelegramProductsUserGetDescriptionGenerationQueueItemQueryKey = ReturnType<
  typeof telegramProductsUserGetDescriptionGenerationQueueItemQueryKey
>;

export function telegramProductsUserGetDescriptionGenerationQueueItemQueryOptions(
  queueId: TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams['queueId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserGetDescriptionGenerationQueueItemQueryKey(queueId);
  return queryOptions<
    TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem401
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem404
    >,
    TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
    typeof queryKey
  >({
    enabled: !!queueId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserGetDescriptionGenerationQueueItem(queueId, config);
    },
  });
}

/**
 * {@link /api/user/telegram/products/description-generation/queue/:queueId}
 */
export function useTelegramProductsUserGetDescriptionGenerationQueueItem<
  TData = TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
  TQueryData = TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserGetDescriptionGenerationQueueItemQueryKey,
>(
  queueId: TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams['queueId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
        ResponseErrorConfig<
          | TelegramProductsUserControllerGetDescriptionGenerationQueueItem401
          | TelegramProductsUserControllerGetDescriptionGenerationQueueItem404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserGetDescriptionGenerationQueueItemQueryKey(queueId);

  const query = useQuery(
    {
      ...telegramProductsUserGetDescriptionGenerationQueueItemQueryOptions(queueId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem401
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
